import { render } from "./App.vue?vue&type=template&id=3b92b983"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3b92b983&lang=scss"

import exportComponent from "C:\\Users\\victoria.matthews\\Documents\\yield-client\\yield-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__